const styles = ({ COLORS }) => ({
  section: {
    border: 'none',
    '& > div': {
      marginBottom: '0'
    }
  },
  container: {
    padding: '0 10px'
  },
  title: {
    margin: 0,
    color: '#aeaeae'
  }
})

export default styles
